module.exports = __webpack_public_path__ + "img/flag.60d379fc.svg";